import { useTranslation } from "react-i18next";

export const useRebateProgramCellTranslate = () => {
  const { t } = useTranslation();

  return {
    hoid: (offerID: string) =>
      t("clientsPage_tradingTable_rebateProgram_hoid", {
        offerID,
        defaultValue: "HOID {{offerID}}",
      }),
    moreSubIBs: (count: number) =>
      t("clientsPage_tradingTable_rebateProgram_moreSubIBs", {
        count,
        defaultValue: "+{{count}}",
      }),
    sharedTooltip: t("clientsPage_tradingTable_rebateProgram_sharedTooltip", {
      defaultValue: "This program is shared with Sub IB. Click to view details",
    }),
  };
};
